import clsx from 'clsx';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../../../EmptyFragment';
import { T } from '../../../../../../../../../Translations';
import Button from '../../../../../../../../Form/Button';
import CheckmarkIcon from '../../../../../../../AddParticipantModal/Modal/ParticipantsAddedModal/CheckmarkIcon';
import { Success } from '../RemoveParticipantStore/Types';

interface Props {
  state: Success;
  closeModal: () => void;
}

function SuccessfullyRemoved({ closeModal, state }: Props) {
  return (
    <div className="flex flex-col items-center">
      <CheckmarkIcon className="mx-auto mt-16" />
      {state.participant.payload.fullName
        .map((participantName) => (
          <div className="font-semibold text-2xl">
            <T
              kind="Participant {{participantName}} removed from {{groupName}}"
              participantName={participantName}
              groupName={state.groupResource.payload.name}
            />
          </div>
        ))
        .getOrElse(emptyFragment)}
      <Button
        className={clsx(
          'rounded-md cursor-pointer bg-teal-600 text-white px-3 py-3 text-sm w-1/3',
          'text-center mt-10 mb-4 mx-auto',
        )}
        value="Return to Participants"
        type="button"
        onClick={closeModal}
      />
    </div>
  );
}

export default observer(SuccessfullyRemoved);
